import React from 'react';
import ClassAssembly  from 'views/ClassAssembly4E';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;